import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import SectionLoader from "./sectionloader";

export const SliderBanner = () => {
  const [time, setTime] = useState(false);
  const data = useSelector((g) => g?.games?.data);
  const { banners, loading } = useSelector((state) => state.interface);
  const settings = {
    dots: false,
    infinite: true,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  const images = [
    "images/sliderimages/bluedragon.png",
    "images/sliderimages/firekirin.png",
    "images/sliderimages/luckypenny.png",
    "images/sliderimages/orionstars.png",
    "images/sliderimages/quakehot.png",
    "images/sliderimages/riversweeps.png",
    "images/sliderimages/sharksecret.png",
  ];
  const ListofGames = {
    infinite: true,
    slidesToShow: 1,
    speed: 1800,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  const FuncationTimer = () => {
    setInterval(() => {
      setTime(true);
      return () => clearInterval(FuncationTimer);
    }, 3000);
  };
  useEffect(() => {
    FuncationTimer();
  }, []);

  return (
    <div className="flex justify-between items-center w-full gap-2">
      <div
        className={`max-sm:w-full ${
          !data?.remainggames?.length > 0 ? "w-[85%]" : "w-full "
        }`}
      >
        {loading ? (
          <SectionLoader aspectRatio="640/187" />
        ) : (
          <Slider {...settings}>
            {banners.map((banner) => (
              <div className="outline-none">
                <img
                  className="rounded-lg"
                  src={banner.url}
                  alt="Slide 1"
                  style={{ width: "100%" }}
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
      {!data?.remainggames?.length > 0 ? (
        <div className="w-[15%] relative hidden lg:flex">
          {" "}
          <Slider {...ListofGames}>
            {images.map((image, index) => (
              <div key={index} className="outline-none">
                <img src={image} alt={`Slide outline-none ${index + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
